var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import GlobalVue from "../../globalVue";
import OrderImportTemplateService from '../../api/OrderImportTemplateService';
import Add from './Add';
import Edit from './Edit';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [1, 2, 3, 4, 5];
        _this.selectRows = [];
        _this.total = 0;
        _this.filter = {
            keyword: ''
        };
        _this.tableHeight = document.body.clientHeight - 160;
        return _this;
    }
    List.prototype.created = function () {
        this.service = OrderImportTemplateService.getInstance();
    };
    List.prototype.mounted = function () {
        this.getList();
    };
    List.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getListPoo(Object.assign(this.filter, pager)).then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.total = res.data.total;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    List.prototype.search = function () {
        this.getList();
    };
    List.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    List.prototype.add = function () {
        this.addTab({
            component: Add,
            title: '添加模板',
            showExist: true,
            name: 'template_add',
            cprops: {}
        });
    };
    List.prototype.edit = function (row) {
        this.addTab({
            component: Edit,
            title: '编辑模板',
            showExist: true,
            name: 'template_edit' + row.template_id,
            cprops: {
                templateId: row.template_id
            }
        });
    };
    List.prototype.deleteRow = function (row) {
        var _this = this;
        this.$confirm("确定要删除该模板吗？", "提示", {
            cancelButtonText: "取消",
            confirmButtonText: "确定",
            dangerouslyUseHTMLString: true
        }).then(function (res) {
            _this.service.delPoo({
                template_id: row.template_id
            }).then(function (res) {
                if (res.data && res.data.success) {
                    _this.$message.success(res.data.msg || '删除模板成功');
                    _this.getList();
                }
            });
        });
    };
    List.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    List = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], List);
    return List;
}(Vue));
export default List;
